import { blueGrey } from '@material-ui/core/colors';
import { makeStyles, Theme, createStyles, Paper, Typography } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        rootContent: {
            padding: theme.spacing(2),
        },
        header: {
            color: blueGrey[900],
            marginBottom: theme.spacing(2),
        },
    })
);